const permissoes = {
    listaPermissoes: [],
    listaPermissoesDepartamento: [],
    limparLista: () => permissoes.listaPermissoes = []
}

export { permissoes }

